module.exports = __webpack_public_path__ + "static/dove-b172792ca1e4b0bda6003bb0425c3ade.jpg";